import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBarNarrow20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconBarNarrow20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 9.5H3a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1M3 8a2 2 0 1 0 0 4h14a2 2 0 1 0 0-4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBarNarrow20);
